export const STUDENT_DEBIT_ITEM_TYPES = {
  lesson: 'Lekcja',
  payment: 'Wpłata'
}

export const STUDENT_ACCOUNTS = {
  account1: 'Smart 1',
  account2: 'Smart 2',
  account3: 'Faktury 1',
  account4: 'Faktury 2',
  account5: 'BLIK'
}

export const BLIK_ACCOUNT_KEY = 'account5'
